/* eslint-disable @typescript-eslint/dot-notation */
import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { NbInputModule } from '@nebular/theme';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-string-translation',
    templateUrl: './string-translation.component.html',
    styleUrls: ['./string-translation.component.css'],
    imports: [NgIf, NbInputModule, FormsModule]
})
export class StringTranslationComponent implements OnInit {
  @Input() public language: Object;
  @Input() public xliff: Object;
  @Input() public editable = true;

  public languageDisplay: string;

  constructor() {}

  public ngOnInit(): void {
    this.languageDisplay = this.language['key'] + ' - ' + this.language['value'];
  }
}
